import type { ApiError, PlayerResponse } from "./types";

const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, "") ?? "";

export class TrackerApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(message);
  }
}

export function parseRiotId(input: string): { gameName: string; tagLine: string } | null {
  const value = input.trim();
  const separator = value.lastIndexOf("#");
  if (separator <= 0 || separator === value.length - 1) return null;
  const gameName = value.slice(0, separator).trim();
  const tagLine = value.slice(separator + 1).trim();
  if (gameName.length > 16 || tagLine.length > 5 || /[\\/]/.test(value)) return null;
  return { gameName, tagLine };
}

export async function getPlayer(gameName: string, tagLine: string, signal?: AbortSignal): Promise<PlayerResponse> {
  const response = await fetch(`${baseUrl}/api/player/${encodeURIComponent(gameName)}/${encodeURIComponent(tagLine)}`, {
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok) {
    let body: ApiError | undefined;
    try { body = await response.json() as ApiError; } catch { body = undefined; }
    const fallback = response.status === 404 ? "That Riot account could not be found." : "The tracker API is unavailable right now.";
    throw new TrackerApiError(body?.error.message ?? fallback, response.status, body?.error.code ?? "API_ERROR");
  }
  return response.json() as Promise<PlayerResponse>;
}
